import * as React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AirSchedule } from '@lce/slice';
import { map as _map, find as _find } from 'lodash';

import { useBanners } from '../lib/banners';
import { Templates } from '../templates';
import { formatAirScheduleDate } from '../lib/util';

interface BannermaticProps {
  baseUrl: string;
  locale: string;
}

const queryClient = new QueryClient();

export const Bannermatic: React.FC<BannermaticProps> = props => {
  return (
    <QueryClientProvider client={queryClient}>
      <BannerManager {...props} />
    </QueryClientProvider>
  );
};

const BannerManager: React.FC<BannermaticProps> = ({ baseUrl, locale }) => {
  const { data: banners, isLoading } = useBanners({ baseUrl, locale });

  return (
    <>
      {!isLoading && banners && _map(banners, banner => {
        const Banner = Templates[banner.template];

        const isBannermaticExist = _find(Object.entries(Templates), ([key]) => key === banner?.template);
        
        if(!isBannermaticExist){
          return null;
        }
        else if (banner && banner.dates && banner.dates.length > 0) {

          return _map(banner.dates, (date, index) => {
            const dates = formatAirScheduleDate(date.startDate, date.endDate);
            return (
              <AirSchedule {...dates} key={`${banner.campaign}-${banner.content.heading}${index}`}>
                <Banner {...banner.content} locale={locale} mb={4} />
              </AirSchedule>
            );
          });
        } else {
          const dates = formatAirScheduleDate(banner.startDate, banner.endDate);

          return (
            <AirSchedule {...dates} key={`${banner.campaign}-${banner.content.heading}`}>
              <Banner {...banner.content} locale={locale} mb={4} />
            </AirSchedule>
          );
        }
      })}
    </>
  );
};
